/**
 * WB3-P2-6 — Publish derived WorkbenchFocus to shell-level consumers (GlobalSearch command palette).
 * Focus is always workspace-derived via BusinessWorkbenchRuntime or legacy WorkbenchInteraction shim.
 */

import type { WorkbenchFocus } from '@shared/business-workbench/workbench-focus';

let activeFocus: WorkbenchFocus | null = null;
const listeners = new Set<() => void>();

export function setActiveWorkbenchCommandFocus(focus: WorkbenchFocus | null): void {
  activeFocus = focus;
  for (const listener of listeners) {
    listener();
  }
}

export function getActiveWorkbenchCommandFocus(): WorkbenchFocus | null {
  return activeFocus;
}

export function subscribeActiveWorkbenchCommandFocus(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Test-only reset */
export function resetActiveWorkbenchCommandFocusForTests(): void {
  activeFocus = null;
  listeners.clear();
}
